<template>
  <div class="wc-row">
    <div class="wc-col">
      <!-- Quote Details Header -->
      <QuoteTile
        v-if="t_motorQuote"
        :quote-id="quoteId"
        :motorQuote="t_motorQuote"
        :isDetailHeader="true"
        :partner-proxy-id="partnerProxyId!"
      ></QuoteTile>

      <!-- Quote Details -->
      <MotorPolicyDetails :quote-id="quoteId" :isQuote="true"></MotorPolicyDetails>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onBeforeMount, type Ref, ref } from 'vue'
import MotorPolicyDetails from '@/components/motor/MotorPolicyDetails.vue'
import { useRoute } from 'vue-router'
import { getPartnerProxyId } from '@/utils/KeycloakUtils'
import QuoteTile from '@/components/quote/QuoteTile.vue'
import { usePoliciesStore } from '@/stores/policiesStore'
import type { ShowOrDeleteQuotes } from '@/types/policy/PolicyTypes'

const route = useRoute()

const partnerProxyId = getPartnerProxyId()
const quoteId = ref(route.params.quoteId!.toString())
const t_motorQuote: Ref<ShowOrDeleteQuotes | null> = ref(null)
const quotes: Ref<Map<string, ShowOrDeleteQuotes>> = ref(
  new Map<string, ShowOrDeleteQuotes>()
)

onBeforeMount(async () => {
  if (partnerProxyId)
    quotes.value =
      await usePoliciesStore().getQuoteDetailsMapByPartnerProxyId(partnerProxyId)

  t_motorQuote.value = quotes.value.get(quoteId.value)!
})
</script>
